import { _ as __rest } from './_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import '@ids/tools';
import { u as useId } from './use-id.js';
import { I as IdsFormField } from './form-field.js';
import { s as styleInject } from './style-inject.es.js';
import { u as useFormField } from './use-form-field.js';

var css_248z = "/*\n** Voxel Foundation Formats\n*/\n.ids-input {\n  background: transparent;\n  border: 0;\n  border-bottom: var(--ids_size_border_small) solid var(--ids_color_border_medium);\n  caret-color: var(--ids_color_action_primary_base);\n  color: var(--ids_color_action_neutral_variant);\n  display: block;\n  font: var(--ids_textStyle_f02_s20_h26_wrg);\n  outline-offset: 0.1875rem;\n  resize: vertical;\n  -webkit-transition: border-color 250ms;\n  transition: border-color 250ms;\n  width: 100%;\n}\n.ids-input:where(textarea) {\n  min-height: var(--ids_size_general_52x);\n}\n.ids-input:-moz-read-only {\n  color: var(--ids_color_action_neutral_base);\n  resize: none;\n}\n.ids-input:read-only, .ids-input:disabled {\n  color: var(--ids_color_action_neutral_base);\n  resize: none;\n}\n.ids-input:focus {\n  border-bottom: var(--ids_size_border_medium) solid var(--ids_color_action_primary_base);\n  outline: 5px auto Highlight;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n.ids-input--large {\n  font: var(--ids_textStyle_label_xlarge_bold);\n}\n.ids-input--no-label {\n  font: var(--ids_textStyle_f02_s16_h24_wrg);\n  text-align: center;\n}\n@media (pointer: coarse) {\n  .ids-input {\n    overflow: hidden;\n    resize: none;\n  }\n}";
styleInject(css_248z);

const IdsInput = _a => {
  var {
      id: externalId,
      label,
      description,
      errorMessage,
      prefix,
      suffix,
      defaultValue,
      value: externalValue,
      onChange,
      onFocus,
      onBlur,
      className = '',
      formFieldProps,
      formMessageProps
    } = _a,
    props = __rest(_a, ["id", "label", "description", "errorMessage", "prefix", "suffix", "defaultValue", "value", "onChange", "onFocus", "onBlur", "className", "formFieldProps", "formMessageProps"]);
  const id = useId(externalId, 'ids-react-input');
  const {
    disabled,
    readOnly
  } = props;
  const ref = useRef();
  const {
    focus,
    handleBlur,
    handleFocus,
    handleChange,
    value
  } = useFormField({
    defaultValue,
    value: externalValue,
    onChange,
    onFocus,
    onBlur,
    disabled,
    readOnly
  });
  const invalid = focus === false && ref && !ref.current.checkValidity();
  return jsx(IdsFormField, Object.assign({
    htmlFor: id,
    label: label,
    focus: focus,
    prefix: prefix,
    suffix: suffix,
    invalid: invalid,
    hasValue: Boolean(value),
    disabled: disabled,
    readOnly: readOnly,
    description: description,
    errorMessage: errorMessage,
    className: className
  }, formFieldProps, {
    formMessageProps: Object.assign({
      children: formMessageProps === null || formMessageProps === void 0 ? void 0 : formMessageProps.children
    }, formMessageProps)
  }, {
    children: jsx("input", Object.assign({
      ref: ref,
      className: "ids-input",
      onBlur: handleBlur,
      onFocus: handleFocus,
      onChange: handleChange,
      "aria-invalid": invalid,
      value: value,
      id: id
    }, props))
  }));
};

export { IdsInput as I };
//# sourceMappingURL=input.js.map
